// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2P26-","minusButton":"_2LevE"};